import axios from 'axios';
import { getAuthHeader } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export interface PendingPatient {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  schoolId?: string;
  requestedAt: string;
}

export interface PagedResponse<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

export interface PatientStatusUpdateRequest {
  action: 'APPROVE' | 'REJECT';
}

class PendingPatientsService {
  
  async getPendingPatients(page = 0, size = 10): Promise<PagedResponse<PendingPatient>> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/providers/pending-patients?page=${page}&size=${size}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch pending patients');
    }
  }

  async approvePatient(studentId: number): Promise<any> {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/providers/pending-patients/${studentId}/approve`,
        {},
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to approve patient');
    }
  }

  async rejectPatient(studentId: number): Promise<any> {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/providers/pending-patients/${studentId}/reject`,
        {},
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to reject patient');
    }
  }

  async updatePatientStatus(studentId: number, action: 'APPROVE' | 'REJECT'): Promise<any> {
    try {
      const request: PatientStatusUpdateRequest = { action };
      const response = await axios.post(
        `${API_BASE_URL}/providers/pending-patients/${studentId}/status`,
        request,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to update patient status');
    }
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString();
  }

  formatDateTime(dateString: string): string {
    return new Date(dateString).toLocaleString();
  }
}

export const pendingPatientsService = new PendingPatientsService();